import { LoadSurgicalPendency } from 'domain/usecases/surgical-pendency/load-surgical-pendency'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteLoadSurgicalPendency implements LoadSurgicalPendency {
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}
  load(surgical_order_id: number): Promise<LoadSurgicalPendency.Model> {
    return this.surgicalPendencyRepository.loadSurgicalPendency(
      surgical_order_id
    )
  }
}
